import { Outlet } from "react-router-dom";

const AllServicesRoot = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
};

export default AllServicesRoot;